import { IApplicationState } from '../../../../../types/types';
import { EViewTypes } from '../../../../../const';

export const getRealTypeSwitcherActiveType = (
    state: IApplicationState,
    boardId: number
): EViewTypes => {
    return state.typeSwitcher[boardId] && state.typeSwitcher[boardId].activeType;
};
